import {FooterScreen,Header} from "../shared"

export const AboutScreen=() => {
    return (
        <>
            <Header />
            <div className="fables-header fables-after-overlay bg-rules">
                <div className="container">
                    <h2 className="fables-page-title fables-second-border-color wow fadeInLeft" data-wow-duration="1.5s">About Us</h2>
                </div>
            </div>

            <div className="fables-history-section mb-4 mb-md-5">
                <div className="container">
                    <div className="fables-about-head-style mt-3">
                        <div className="row wow fadeInDown" data-wow-delay=".5s">
                            <div className="col-12 text-center">
                                <h3 className="fables-about-top-head fables-forth-text-color font-15 semi-font d-inline-block bg-white position-relative">
                                    <span className="mx-4">Who We Are</span>
                                </h3>
                                <div className="col-12 col-md-10 offset-md-1">
                                    <h2 className="fables-second-text-color mt-3 font-30 font-weight-bold text-center">Institutionalizing Growth in Regulated Environments</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mb-4 mb-md-5">
                <div className="row">
                    <div className="col-12 col-md-10 offset-md-1">
                        <p className="fables-forth-text-color font-16 mb-4">
                            At Kovio, we focus on a recurring structural problem in regulated industries: innovation outpaces institutional execution.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4">
                            In healthcare, medical devices, and life sciences, companies often succeed at the pilot stage but struggle to scale within the operational, regulatory, and commercial constraints required for durable growth.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-2">
                            The risk is rarely capital.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-2">
                            It is rarely vision.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4 font-weight-bold">
                            It is execution architecture.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4">
                            Kovio was founded to close that gap.
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-rules mb-4 mb-lg-0 py-3 py-lg-0" style={{backgroundImage: 'url(/assets/custom/images/mission-img.jpg)'}} />
            <div className="container mb-4 mb-md-5">
                <div className="row">
                    <div className="col-12 col-md-10 offset-md-1">
                        <h2 className="fables-second-text-color font-30 font-weight-bold mb-4">The Execution Partner Model</h2>
                        <p className="fables-forth-text-color font-16 mb-4">
                            Kovio operates as an embedded Execution Partner to leadership teams and their investors.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4">
                            We are engaged when growth must become institutional.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4">
                            Our work centers on three integrated domains:
                        </p>
                        <ul className="fables-forth-text-color font-16 mb-4" style={{listStyleType: 'disc', paddingLeft: '20px'}}>
                            <li className="mb-2"><strong>Regulatory & Quality Execution:</strong> Operationalizing compliance as a daily discipline rather than a documentation exercise.</li>
                            <li className="mb-2"><strong>Revenue & Commercial Structure:</strong> Aligning growth velocity with execution capacity.</li>
                            <li className="mb-2"><strong>Applied AI Governance & Architecture:</strong> Deploying AI in ways that create leverage without introducing structural risk.</li>
                        </ul>
                        <p className="fables-forth-text-color font-16 mb-2">
                            These domains are inseparable.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-2">
                            Growth without regulatory discipline creates fragility.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-2">
                            AI without governance creates exposure.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4">
                            Commercial scale without structure creates remediation.
                        </p>
                    </div>
                </div>
            </div>

            <div className="container mb-4 mb-md-5">
                <div className="row">
                    <div className="col-12 col-md-10 offset-md-1">
                        <h2 className="fables-second-text-color font-30 font-weight-bold mb-4">Our Approach</h2>
                        <p className="fables-forth-text-color font-16 mb-2">
                            We do not deliver projects.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4 font-weight-bold">
                            We embed execution architecture.
                        </p>
                        <ul className="fables-forth-text-color font-16 mb-4" style={{listStyleType: 'disc', paddingLeft: '20px'}}>
                            <li className="mb-2">Structured operating cadence</li>
                            <li className="mb-2">Cross-functional accountability</li>
                            <li className="mb-2">Regulatory-readiness integration</li>
                            <li className="mb-2">Commercial milestone alignment</li>
                        </ul>
                        <p className="fables-forth-text-color font-16 mb-4">
                            We operate as an external Operating Partner, aligned with leadership, visible to boards, accountable to outcomes.
                        </p>
                    </div>
                </div>
            </div>

            <div className="container mb-4 mb-md-5">
                <div className="row">
                    <div className="col-12 col-md-10 offset-md-1">
                        <h2 className="fables-second-text-color font-30 font-weight-bold mb-4">Strategic Advisors</h2>
                        <p className="fables-forth-text-color font-16 mb-4">
                            Kovio collaborates with senior leaders who have shaped regulatory systems, enterprise operating models, and industry standards.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-3">
                            Advisors contribute perspective on:
                        </p>
                        <ul className="fables-forth-text-color font-16 mb-4" style={{listStyleType: 'disc', paddingLeft: '20px'}}>
                            <li className="mb-2">Regulatory interpretation and modernization</li>
                            <li className="mb-2">Scalable execution frameworks</li>
                            <li className="mb-2">Structural risk identification</li>
                            <li className="mb-2">Institutional operating discipline</li>
                        </ul>
                        <p className="fables-forth-text-color font-16 mb-4">
                            Advisor engagement is structured, focused, and high-leverage.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4 font-weight-bold">
                            We value substance over visibility.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-2">
                            Kovio is not a consultancy.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4 font-weight-bold">
                            It is an execution architecture firm.
                        </p>
                        <p className="fables-forth-text-color font-16 mb-4">
                            We help ensure that innovation in regulated industries becomes durable, investable, and scalable.
                        </p>
                    </div>
                </div>
            </div>
            <FooterScreen />
        </>
    )
}